import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { racecardHref, resultHref, raceStatusLabel } from 'modules/HorseRacing/utils';
import { toSlug } from 'utils';
import {canonicalLink} from 'utils/seoUtils';
import {localTimeShort, localFullDateNoDay, localFullDateLong} from 'utils/LocalDateTimeHelper';

import AdvertWrapper from "modules/Common/components/AdvertWrapper";
import Dropdown from 'modules/Common/components/Dropdown';
import SwitchBtns from 'modules/Common/components/SwitchBtns';
import CaretLink from 'modules/Common/components/CaretLink';

import { HORSE_RACE_COMPLETE_STATUSES } from 'modules/Common/consts';

require("./HorseRacingRacePage.scss");

export default function HorseRacingRacePage(props) {
  const {
    children,
    params,
    routes,
    route: {
      "result-racecard": resultRacecard
    },
    meeting: raceMeeting, // for passing on
    meeting: {
      meeting: [{
        meeting_summary: {
          meeting_reference: {
            id: meetingId
          } = {}
        } = {}
      } = {}] = []
    } = {},
    race, // for passing on
    race: {
      race_summary : {
        time : raceTime,
        course_name : courseName = '',
        date : dateLong,
        name : raceName = '',
        race_stage: raceStage,
        race_summary_reference : {
          id : raceId
        }
      }
    },
    meetings: {
      meetings = []
    } = {},
    tipsArticle
  } = props;

  const isOnRaceCard = (resultRacecard == "racecard");
  let dropdownHref;

  if (isOnRaceCard) {
    dropdownHref = (date, course_name, race_id, race_name) => racecardHref({date, course_name, race_id, race_name});
  }
  else {
    dropdownHref = (date, course_name, race_id, race_name) => resultHref({date, course_name, race_id, race_name});
  }

  const meetingsOnThisDay = meetings.map(({
      meeting_summary: {
        course: {
          name: courseName = ''
        }
      },
      races: [
        {
          name: raceName = '',
          race_summary_reference: {
            id: raceId
          }
        }
      ]
    }) => ({
      href: dropdownHref(dateLong, courseName, raceId, raceName),
      text: courseName
    })
  );

  const londonRaceTime = localTimeShort(`${dateLong}T${raceTime}Z`);
  const courseNameSlug = toSlug(courseName);
  const helmetDate = localFullDateNoDay(dateLong || new Date());
  const headingDate = localFullDateLong(dateLong || new Date());

  const helmetRaceLabel = `${londonRaceTime} ${courseName} - ${helmetDate}`;

  const switchBtnHref = page => `/racing/racecards/${dateLong}/${courseNameSlug}/${page}/${raceId}/${toSlug(raceName)}`;

  const canonicalParams = {
    date: dateLong,
    courseSlug: toSlug(courseName),
    raceId,
    raceSlug: toSlug(raceName)
  };

  const cloneProps =  {
    race,
    meeting: raceMeeting,
    tipsArticle,
    helmetRaceLabel
  };

  const isComplete = HORSE_RACE_COMPLETE_STATUSES.includes(raceStage)

  cloneProps.params = params;
  const showButtons = !isComplete && isOnRaceCard;
  const addProps = {
      location: "/racing/racecards",
      view: "racecard"
  };

  return (
    <div className="hr-racing-racecard-wrapper">
      <MetaDataWrapper helmetProps={{...canonicalLink(routes, canonicalParams)}}/>
      <section className="hr-racing-racecard-top-section">
        <div className="dropdown-wrapper">
          <Dropdown title="Meetings" options={meetingsOnThisDay} shouldNavigate={true}/>
        </div>

        { showButtons &&
          <SwitchBtns buttons={[
            {href: switchBtnHref('racecard'),  text: 'Racecard', isIndex: true},
            {href: switchBtnHref('live-show'), text: 'Live Show'}
          ]}/>
        }

        <div className="hr-racing-racecard-heading">
          <div className="hr-racing-racecard-heading-text">
            <h1>{londonRaceTime}&nbsp;{courseName} <small>{headingDate}</small></h1>
          </div>
          <div className="hr-racing-racecard-heading-link">
            <CaretLink to={`/racing/fast-cards/${meetingId}/${dateLong}/${courseNameSlug}`}>Fast Cards</CaretLink>
          </div>
          {!isComplete && <div className="hr-racing-racecard-status">
              {raceStatusLabel(raceStage)}
            </div>
          }
        </div>
      </section>

      {children && React.cloneElement(children, cloneProps)}

      <AdvertWrapper ocSlot={["racing", "leaderboard"]} additionalProperties={addProps} />
    </div>
  );
}

HorseRacingRacePage.propTypes = {
  route: PropTypes.object,
  params: PropTypes.object,
  routes: PropTypes.array.isRequired,
  race : PropTypes.object.isRequired,
  meeting: PropTypes.object,
  meetings: PropTypes.object,
  children: PropTypes.node,
  tipsArticle: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacePage.js